export const vision = {
label: 'DIRECCIÓN ESTRATÉGICA',
title: 'Dirección Estratégica',
subtitle: 'Principios rectores que impulsan nuestras operaciones y excelencia empresarial.',
vision_title: 'Nuestra Visión',
vision_text: 'Construir una empresa confiable reconocida por la calidad de sus productos, crecimiento responsable, disciplina operativa y relaciones empresariales a largo plazo.',
mission_title: 'Nuestra Misión',
mission_text: 'Proporcionar productos de bienestar y cuidado personal de calidad a través de ventas directas responsables, operaciones disciplinadas, desarrollo de mercado sostenible y relaciones sólidas con clientes, distribuidores independientes y socios comerciales.',
pillars_title: 'Pilares Estratégicos',
pillar_1: 'Excelencia Operativa',
pillar_1_desc: 'Mantener altos estándares operativos y coordinación efectiva entre mercados.',
pillar_2: 'Disciplina de Mercado',
pillar_2_desc: 'Ejecutar estrategias de mercado con atención al cumplimiento regulatorio y eficiencia operativa.',
pillar_3: 'Calidad del Producto',
pillar_3_desc: 'Entregar productos de bienestar de calidad a través de posicionamiento estratégico y distribución.',
pillar_4: 'Crecimiento Sostenible',
pillar_4_desc: 'Construir estructuras empresariales escalables que apoyen la presencia de mercado a largo plazo y el valor.',
};
